import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";

interface FinancialInformationContainerProps {
  userId: string;
  propertyId: string;
}

export const FinancialInformationContainer: React.FC<
  FinancialInformationContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ pl: 6 }}>
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Monthly Strata Fees"
        fieldKey="financialInformation.monthlyStrataFees"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="CRF Current Balance"
        fieldKey="financialInformation.contingencyReserveFund.currentBalance"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Recent CRF Expenditures"
        fieldKey="financialInformation.contingencyReserveFund.recentExpenditures"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Anticipated Future CRF Spending"
        fieldKey="financialInformation.contingencyReserveFund.anticipatedFutureSpending"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="CRF Analysis"
        fieldKey="financialInformation.contingencyReserveFund.analysis"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Current Special Levies"
        fieldKey="financialInformation.specialLevies"
      />
    </Box>
  );
};
